import { motion } from 'framer-motion';

type SamIconProps = {
  animate?: boolean;
};

export const SamIcon = ({ animate = false }: SamIconProps) => {
  return (
    <motion.svg
      animate={animate && { y: [0, -5, 0] }}
      transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut',
      }}>
      <image
        x="0"
        y="0"
        width="100%"
        height="100%"
        href="/sam.png"
        preserveAspectRatio="xMidYMid meet"
        className="object-fill"
      />
    </motion.svg>
  );
};
